exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".com-dimensional-box[data-v-20260900]{display:flex;flex-wrap:wrap;flex-direction:row}.com-dimensional-box .yxt-tree-node__labelGroup[data-v-20260900]{display:flex;align-items:center}.com-dimensional-box__text[data-v-20260900]{font-size:14px;font-weight:400;color:#595959;line-height:22px}\n", ""]);

